module.exports = __webpack_public_path__ + "static/media/didi3.1965827b.wav";